import {
  WSAlert,
  WSFlexBox,
  WSForm,
  WSIcon,
  WSInfoBox,
  WSInputTextarea,
  WSList,
  WSSelect,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { useQueryBackgroundChecksPackages } from "../../../../../query/backgroundChecks/queries/useQueryBackgroundChecksPackages";
import { selectorBackgroundChecksActivePackages } from "../../../../Requirements/selectors/selectorBackgroundChecksActivePackages";

const ListItem: React.FC<{ label: string }> = ({ label }) => {
  return (
    <WSFlexBox.CenterY alignItems="flex-start" wrap="nowrap">
      <WSIcon mr="M" name="shield-check" size="S" />
      <WSText.ParagraphSm>{label}</WSText.ParagraphSm>
    </WSFlexBox.CenterY>
  );
};

export const CreateBackgroundChecksPartialForm: React.FC = () => {
  const { register } = useFormContext();

  const queryBackgroundChecks = useQueryBackgroundChecksPackages();

  const packages = queryBackgroundChecks.data || [];

  const backgroundChecksOptions = selectorBackgroundChecksActivePackages(
    packages
  ).map(backgroundCheckPackage => ({
    label: `${backgroundCheckPackage.title} (${formatMoney(
      backgroundCheckPackage.costPerCheck || 0,
      "USD"
    )} per check)`,
    value: backgroundCheckPackage.backgroundCheckPackageId
  }));

  useEffect(() => {
    register("package");
    register("instructions");
  }, []);

  return (
    <WSList gap="XL">
      <WSAlert
        icon="info-circle"
        theme="info"
        title="About background check requirements"
        // action={{
        //   text: "Learn more",
        //   onClick: () => {
        //     backgroundCheckFeatureUpgradeModal.open({
        //       onSuccess: () => {
        //         alert("BACKGROUND_CHECK_TODO");
        //       }
        //     });
        //   }
        // }}
      >
        Contractor(s) assigned with this requirement (via Engagements) will be
        asked to complete the selected background check package via the
        background check portal. Keep track of the contractor’s requirement
        status on their contractor detail page.
      </WSAlert>

      <WSForm.Field
        component={WSSelect}
        componentProps={{
          options: backgroundChecksOptions,
          required: true
        }}
        label="Background check package"
        name="package"
        shimmer={queryBackgroundChecks.isLoading}
      />

      {queryBackgroundChecks.isFetched &&
        backgroundChecksOptions.length === 0 && (
          <WSAlert theme="error">
            No background check packages available. Please contact support to
            add a package.
          </WSAlert>
        )}

      <WSForm.Value name="package">
        {selectedPackageId => {
          const selectedPackage = queryBackgroundChecks.data?.find(
            itemPackage =>
              itemPackage.backgroundCheckPackageId === selectedPackageId
          );

          return selectedPackageId ? (
            <WSInfoBox>
              <WSList gap="L" py="S">
                <WSText.ParagraphSm color="gray500">
                  Included reports
                </WSText.ParagraphSm>
                {selectedPackage?.searches.map((search, index) => (
                  <ListItem key={index} label={search.title!} />
                ))}
              </WSList>
            </WSInfoBox>
          ) : null;
        }}
      </WSForm.Value>

      <WSForm.Field
        component={WSInputTextarea}
        label="Instructions to contractor"
        name="instructions"
        placeholder="Include any instructions or guidelines for the contractor here (optional)."
      />

      <WSText.ParagraphXs color="gray400" weight="book">
        Wingspan can auto-fill known info like names, emails, custom fields
        which you can configure in the next step.
      </WSText.ParagraphXs>
    </WSList>
  );
};
